import * as React from "react"
import { AnchorLink } from "gatsby-plugin-anchor-links"

const MenuLinks = ({ activeClassName = "", onClickFn = () => { }, linkSizeClass = "leading-normal" }) => (
  <>
    <li className="self-center text-left sm:text-center w-full sm:w-auto animate-menu-fade-in sm:animate-none border-t sm:border-0 border-theme-yellow-30 px-4 sm:px-0">
      <AnchorLink to="#whatwedo" className={`menu-link ${linkSizeClass} my-2 text-center sm:my-0 sm:mx-5 sm:py-p5 sm:inline-block block hover:text-theme-yellow`} activeClassName={activeClassName} onClick={onClickFn}>About Us</AnchorLink>
    </li>
    <li className="self-center text-left sm:text-center w-full sm:w-auto animate-menu-fade-in sm:animate-none border-y sm:border-0 border-theme-yellow-30 px-4 sm:px-0">
      <AnchorLink to="#contact" className={`border-solid border-2 px-4 text-center  border-slate-400 menu-link ${linkSizeClass} my-2 sm:my-0 sm:ml-5 sm:py-p5 sm:inline-block block hover:text-theme-yellow`} activeClassName={activeClassName} onClick={onClickFn}>Get in Touch</AnchorLink>
    </li>
  </>
)

export default MenuLinks